import config from "../../config";
import $axios from "@/plugins/axios";

const url = `${config.baseUrl}`;

export class GalleryService {
    getPhotoGallery (page, size) {
        return $axios.get(`${url}photogallery/published/${page}/${size}`).then((res) => res.data);
    }
    getPhotoGalleryById (id) {
        return $axios.get(`${url}photogallery/published/${id}`).then((res) => res.data);
    }
    getVideoGallery (page, size) {
        return $axios.get(`${url}videogallery/${page}/${size}`).then((res) => res.data);
    }
}
